import { TextButtonLink } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { PerformanceByVenueInsight } from 'apis/merchant-gateway/insights';

import usePerformanceByVenueTableProps from './hooks/usePerformanceByVenueTableProps';
import { InsightResponsePaginated, RowType } from '../../types';
import SummaryTable from '../InsightSummary/SummaryTable';
import PerformanceByVenueTable, { VenueTableSortableColumnIDs } from '../tables/performance/PerformanceByVenueTable';
import { SortState } from '../tables/types';

type PerformanceByVenueCardProps = {
  isVATEnabled: boolean;
  performanceByVenueInsights: InsightResponsePaginated<PerformanceByVenueInsight>;
  sort: SortState<VenueTableSortableColumnIDs> | undefined;
  setSort: (sort: SortState<VenueTableSortableColumnIDs> | undefined) => void;
  onShowAll?: () => void;
};

export const PerformanceByVenueCard = ({
  isVATEnabled,
  performanceByVenueInsights,
  sort,
  setSort,
  onShowAll,
}: PerformanceByVenueCardProps) => {
  const { formatMessage } = useIntl();

  const tableProps = usePerformanceByVenueTableProps({ isVATEnabled, sort, setSort, performanceByVenueInsights });

  const showAllButton = (
    <TextButtonLink onClick={() => onShowAll?.()}>
      <FormattedMessage id="insights.performance.table.show-all" />
    </TextButtonLink>
  );

  return (
    <SummaryTable
      onRetry={performanceByVenueInsights.refetch}
      isError={
        performanceByVenueInsights.isError ||
        (performanceByVenueInsights.isLoading && !performanceByVenueInsights.isFetching)
      }
      isFetching={performanceByVenueInsights.isFetching}
      link={showAllButton}
      title={formatMessage({ id: 'insights.performance.table.performance-by-venue' })}
      rows={[
        {
          type: RowType.Raw,
          key: 'raw',
          content: <PerformanceByVenueTable {...tableProps} />,
        },
      ]}
    />
  );
};
